import HM from './hook-manager';

// Filters:
//  * `wakefly/breakpoints` - Passes the default breakpoint list for modification

class Globals {
  get breakpoints() {
    var breakpoints = {
      'xs': 0,
      'sm': 576,
      'md': 768,
      'lg': 992,
      'xl': 1200,
      'xxl': 1440
    };
    breakpoints = HM.do_filter('wakefly/breakpoints', breakpoints);

    return breakpoints;
  }
}

export default new Globals();
